import { Chip } from "@mui/material";

export type StatusTone = "success" | "warning" | "neutral" | "error";

const tones: Record<StatusTone, { background: string; color: string }> = {
  success: { background: "#e7f4ea", color: "#245b31" },
  warning: { background: "#f6edd8", color: "#644b18" },
  neutral: { background: "#eeeeec", color: "#4f4f4a" },
  error: { background: "#f9e5e3", color: "#822d26" },
};

export function StatusChip({ label, tone = "neutral" }: { label: string; tone?: StatusTone }) {
  return <Chip label={label} size="small" sx={{ fontWeight: 700, bgcolor: tones[tone].background, color: tones[tone].color }} />;
}
